import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { t } from '../texts';

function InquiryMenuItems({ itemClassName, onNavigate }) {
  return (
    <React.Fragment>
      <li className={itemClassName} onClick={onNavigate}>
        <Link to="/inquiry" onClick={onNavigate}>
          {t('menu.inquiry')}
        </Link>
      </li>
      <li className={itemClassName} onClick={onNavigate}>
        <Link to="/inquiry/qr" onClick={onNavigate}>
          {t('menu.qr')}
        </Link>
      </li>
    </React.Fragment>
  );
}

InquiryMenuItems.propTypes = {
  itemClassName: PropTypes.string,
  onNavigate: PropTypes.func,
};

InquiryMenuItems.defaultProps = {
  itemClassName: 'item',
  onNavigate: undefined,
};

export default memo(InquiryMenuItems);
